import React, { useRef, useState } from 'react';
import CompGridMatchTrmnt from '@components/grid/comp-grid-matchtrmnt.js';
import CompFormMatchTrmnt from '@components/form/comp-form-matchtrmnt.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid} from '@assets/js/api/commonApi.js';

const MatchTrmntMng = (props) => {
    /****************************
     * Define required variables
     *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState({ ids: [], data: [] });

    /**************************
     * Define button functions
     ***************************/
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    // const onRemove = () => {
    //     if (!selectedRows || !selectedRows.ids || selectedRows.ids.length === 0) { alert('1건이상 선택해주세요.'); return; }
    //     const idsArray = [...selectedRows.ids];
    //     if (idsArray.length === 0) {
    //         alert('삭제할 항목을 선택해주세요.');
    //         return;
    //     }

    //     const deleteParams = {
    //         deleteList: idsArray.map(rowId => {
    //             // rowId format: mngCd|mtmkgCd|armType|seedNo
    //             const [mngCd, mtmkgCd, armType, seedNo] = rowId.split('|');
    //             return {
    //                 mngCd: mngCd,
    //                 mtmkgCd: mtmkgCd,
    //                 armType: armType,
    //                 seedNo: seedNo
    //             };
    //         })
    //     };

    //     removeGrid('/sys/matchtrmntmng/remove/info', deleteParams, {
    //         msg: {
    //             confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
    //         }
    //     }).then(res => {
    //         if (res && res.success) {
    //             //clear selected rows grid.
    //             setSelectedRows({ ids: new Set(), data: [] });
    //             onGridSearch();
    //         }
    //     });
    // }
    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
     *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            comptnNm : {
                id: 'comptnNm',
                label: '대회명',
                maxLength : 100,
            },
            dvsnCd : {
                id: 'dvsnNm',
                label: '부문',
                maxLength : 50,
            },
            wetclsNm : {
                id: 'wetclsNm',
                label: '체급',
                maxLength : 50,
            },
            armType : {
                id: 'armType', 
                label: '팔유형', 
                type: 'selectbox', 
                grpCd: 'GRP005', 
            },
        }
    }
    const buttonConfig = {
        leftButtons: [
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />

            {/* Grid */}
            <CompGridMatchTrmnt ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows} />

            {/* Modal popup */}
            <CompFormMatchTrmnt ref={childRef} onGridSearch={onGridSearch} />
        </>
    );
}

export default MatchTrmntMng;
